module.exports = "https://portperrypedals.ca/_res/img/grandview.daae06b.svg";